import PropTypes from "prop-types";
import { Popup } from "semantic-ui-react";
import { Full, Value } from "./styles";

export const FullWithHover = ({
  content = "",
  theme,
  category = "",
  hasNoPTO = false,
}) => {
  const popupContent = hasNoPTO
    ? "No hours available"
    : `${content} hours ${category}`;
  const valueDisplay = hasNoPTO ? "Not available" : content;

  return (
    <Popup
      basic
      content={popupContent}
      trigger={
        <Full style={theme}>
          <Value>{valueDisplay}</Value>
        </Full>
      }
    />
  );
};

FullWithHover.propTypes = {
  content: PropTypes.string,
  hasNoPTO: PropTypes.bool,
  theme: PropTypes.shape({}).isRequired,
  category: PropTypes.string,
};
